import React from 'react';
import Sortable from 'react-sortablejs';
import _get from 'lodash/get';
import CategorySubItem from './CategorySubItem';
import CategoryItemIcon from './CategoryItemIcon';
import {itemStyle, disableItemStyle} from './styles';

export default function CategoryItem({
  item,
  isDisabled,
  toggleItemStatus,
  preview,
  isSupportSubOptions = false,
  type = 'enable',
  sortable = false,
  onDragSubItem,
}) {
  const showSubOptions = isSupportSubOptions
    ? _get(item, 'options', []).length > 0
    : false;

  const isTypeisEnable = type === 'enable';

  return (
    <div
      data-id={item.value}
      style={isDisabled ? disableItemStyle : itemStyle}
      key={item.value}
    >
      <div className="d-flex align-items-center justify-content-center">
        <CategoryItemIcon
          preview={preview}
          sortable={sortable}
          isTypeisEnable={isTypeisEnable}
          itemValue={item.value}
          toggleItemStatus={toggleItemStatus}
        />
        <div className="text-center w-100">{item.label}</div>
        {!preview && (
          <i
            className={`fa ${isTypeisEnable ? 'fa-times' : ''} cursor-pointer`}
            onClick={() => toggleItemStatus(item.value, 'disable', false, true)}
          />
        )}
      </div>
      {showSubOptions && sortable && (
        <>
          {item.options
            .filter(subItem => subItem.isRequired)
            .map(subItem => (
              <CategorySubItem
                key={subItem.value}
                item={subItem}
                isDisabled={isDisabled}
                toggleItemStatus={toggleItemStatus}
                preview={preview}
                sortable={sortable}
              />
            ))}
          <Sortable
            options={{handle: '.draggable', filter: '.fixed'}}
            tag="div"
            onChange={order => onDragSubItem(order, item.value)}
          >
            {item.options
              .filter(subItem => !subItem.isRequired)
              .map(subItem => (
                <CategorySubItem
                  key={subItem.value}
                  item={subItem}
                  isDisabled={isDisabled}
                  toggleItemStatus={toggleItemStatus}
                  preview={preview}
                  sortable={sortable}
                />
              ))}
          </Sortable>
        </>
      )}
      {showSubOptions && !sortable && (
        <>
          {item.options.map(subItem => (
            <CategorySubItem
              key={subItem.value}
              item={subItem}
              isDisabled={isDisabled}
              toggleItemStatus={toggleItemStatus}
              preview={preview}
              sortable={false}
            />
          ))}
        </>
      )}
    </div>
  );
}
